export default {
  title: 'WinOrder',
  form: {
    store_id: {
      label: 'ID magazin: ',
    },
    url: {
      label: 'URL: ',
    },
    username: {
      label: 'Utilizator: ',
      placeholder: 'Utilizator pentru autentificare între magazinul dvs. și WinOrder',
      validation: {
        required: 'Utilizatorul nu poate fi gol',
        min: 'Lungimea minimă a utilizatorului este de 3 caractere',
      },
    },
    password: {
      label: 'Parolă: ',
      placeholder: 'Parolă pentru autentificare între magazinul dvs. și WinOrder',
      validation: {
        required: 'Parola nu poate fi goală',
        complexity: 'Parola trebuie să aibă cel puțin 8 caractere și să conțină cel puțin o literă',
      },
    },
  },
  labels: {
    credentials: 'Credențiale:',
  },
  instructions: {
    title: 'Instrucțiuni de configurare:',
    step_1: 'Deschideți „Setări" → „Setări program" în WinOrder.',
    step_2: 'Chiar în partea de sus veți găsi butonul „Configurare magazin online".',
    step_3:
      'În fereastra următoare veți găsi toate magazinele preconfigurate în WinOrder. Selectați „FoodAmigos" și faceți clic pe „Înainte".',
    step_4:
      'În fereastra următoare, înlocuiți <0>{{storeid_placeholder}}</0> cu <1>{{company_id}}</1> în câmpul „URL serviciu web". <br />Rezultatul final ar trebui să arate astfel: <2>{{url}}</2>',
    step_5: 'În aceeași fereastră, introduceți <ClickToCopy>{{username}}</ClickToCopy> în câmpul „Utilizator".',
    step_6:
      'În aceeași fereastră, introduceți <ClickToCopy>{{password}}</ClickToCopy> în câmpul „Parolă". Apoi faceți clic pe „Înainte".',
    step_7:
      'WinOrder testează acum conexiunea la interfața FoodAmigos. Faceți clic pe „Înainte" și în fereastra următoare pe „Finalizare".',
    step_8: 'Salvați setările.',
  },
  buttons: {
    save: 'Salvează',
    cancel: 'Anulează',
    edit: 'Editează',
  },
  toasts: {
    error: 'Salvarea modificărilor a eșuat',
    success: 'Modificările au fost salvate',
  },
};
